import { saveUserSettingsCookie } from '@Components/Utilities/CookieHelper';
import translator from '@Components/Utilities/Translator';
import Combobox from '@Components/MuiWrappers/Combobox';
import Box from '@mui/material/Box';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const UnitSelector = (props) => {

    const routes = useRecoilValue(atoms.routes);

    const getOptionLabel = (option) => {
        let optionTranslation = '';

        option = option.toLowerCase();
        
        if (option == 'metric') {
            optionTranslation = translator.translate('sandhills.tradepubwebsite.mvc.metric');
        } else {
            optionTranslation = translator.translate('sandhills.tradepubwebsite.mvc.imperial');
        }

        return optionTranslation;
    };

    const renderOption = (optionsProps, option) => {
        return (
            <Box component="li" {...optionsProps}>               
                <div><span>{getOptionLabel(option)}</span></div>
            </Box>
        );
    };

    const onChange = (event, option, reason, details) => {
        if (reason == 'selectOption') {
            if (props.onChange) {
                props.onChange(option);
            } else {
                saveUserSettingsCookie({ unit: option, url: routes.SaveUserSettings })
                    .then(data => {
                        window.location.href = data.url;
                    })
                    .catch(error => {
                        console.log('Error saving UserSettings cookie: ', error);
                        window.location.reload(true);
                    });
            }
        }
    };

    return (
        <div className={props.containerClassName}>
            <Combobox
                label={translator.translate('sandhills.tradepubwebsite.mvc.units')}               
                value={props.value}
                options={props.Units}
                getOptionLabel={getOptionLabel}
                renderOption={renderOption}
                onChange={onChange}
            />
        </div>
    );
};

export default UnitSelector;